module.exports = __webpack_public_path__ + "img/service_progress_2.41cce779.png";